/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Confirm_Password_PlaceholderInputs */

const en_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm your password`)
};

const fr_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmez votre mot de passe`)
};

const de_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen Sie Ihr Passwort`)
};

const it_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma la tua password`)
};

const ru_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите свой пароль`)
};

const es_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma tu contraseña`)
};

const zh_cn2_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认密码`)
};

const ja_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを確認してください`)
};

const hi_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने पासवर्ड की पुष्टि करें`)
};

const pt_pt2_login_confirm_password_placeholder = /** @type {(inputs: Login_Confirm_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirme sua senha`)
};

/**
* | output |
* | --- |
* | "Confirm your password" |
*
* @param {Login_Confirm_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_confirm_password_placeholder = /** @type {((inputs?: Login_Confirm_Password_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Confirm_Password_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_confirm_password_placeholder(inputs)
	if (locale === "de") return de_login_confirm_password_placeholder(inputs)
	if (locale === "it") return it_login_confirm_password_placeholder(inputs)
	if (locale === "ru") return ru_login_confirm_password_placeholder(inputs)
	if (locale === "es") return es_login_confirm_password_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_login_confirm_password_placeholder(inputs)
	if (locale === "ja") return ja_login_confirm_password_placeholder(inputs)
	if (locale === "hi") return hi_login_confirm_password_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_login_confirm_password_placeholder(inputs)
	return en_login_confirm_password_placeholder(inputs)
});